// extracted by mini-css-extract-plugin
export default {"submitButton":"submitButton_submitButton__BmRv-"};